// assets
import { IconUser, IconShieldPlus, IconDashboard, IconListDetails, IconHome } from '@tabler/icons-react';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
// constant
// const icons = { IconDashboard, IconHelp, IconSettings, IconUser, IconListDetails, IconShieldPlus, IconExclamationCircle, IconHome, PaidIcon };

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const dashboard = [{
    id: 'dashboard',
    type: 'group',
    children: [
        {
            id: 'home',
            title: 'Home',
            type: 'item',
            icon: IconHome,
            url: 'home'
        },
        {
            id: 'dashboard',
            title: 'Dashboard',
            type: 'item',
            url: 'dashboard',
            icon: IconDashboard,
            breadcrumbs: false
        },
        {
            id: 'personaldetails',
            title: 'Personal Details',
            type: 'item',
            url: 'personaldetails',
            icon: IconUser,
            breadcrumbs: false
        },
        {
            id: 'bookings',
            title: 'Bookings',
            type: 'item',
            url: 'bookings',
            icon: IconListDetails,
            breadcrumbs: false
        },
        {
            id: 'payouts',
            title: 'Payouts',
            type: 'item',
            url: 'payouts',
            icon: MonetizationOnIcon,
            breadcrumbs: false
        },
        {
            id: 'addpolicy',
            title: 'Offline Policy',
            type: 'collapse',
            icon: IconShieldPlus,

            children: [
                {
                    id: 'health',
                    title: 'Health',
                    type: 'item',
                    url: 'health',
                    target: false
                },
                {
                    id: 'motor',
                    title: 'Motor',
                    type: 'item',
                    url: 'motor',
                    target: false
                },
                {
                    id: 'life',
                    title: 'Life',
                    type: 'item',
                    url: 'life',
                    target: false
                },
                // {
                //   id: 'travel',
                //   title: 'Travel',
                //   type: 'item',
                //   url: 'travel',
                //   target: false
                // },
                {
                    id: 'loan',
                    title: 'Loan',
                    type: 'item',
                    url: 'loan',
                    target: false
                }
            ]
        },
        // {
        //     id: "policyclaims",
        //     title: 'Policy Claims',
        //     type: 'item',
        //     url: 'policyclaims',
        //     icon: IconExclamationCircle,
        //     breadcrumbs: false
        // },
        // {
        //     id: "payouts",
        //     title: 'Payouts',
        //     type: 'item',
        //     url: 'payouts',
        //     icon: MonetizationOnIcon,
        //     breadcrumbs: false
        // },
        // {
        //     id: "invoice",
        //     title: 'Raise Invoice',
        //     type: 'item',
        //     url: 'invoice',
        //     icon: ReceiptIcon,
        //     breadcrumbs: false
        // },
        // {
        //     id: "settings",
        //     title: 'Settings',
        //     type: 'item',
        //     url: 'settings',
        //     icon: IconSettings,
        //     breadcrumbs: false
        // },
        // {
        //     id: "helpline",
        //     title: 'Help Line',
        //     type: 'item',
        //     url: 'helpline',
        //     icon: IconHelp,
        //     breadcrumbs: false
        // },
    ]
}];

export default dashboard;
